import { useTranslation } from 'react-i18next'
import { Button } from '@mui/material'

import SubjectBlock from '../SubjectBlock/SubjectBlock'
import styles from './SemesterSection.module.scss'

const SemesterSection = ({
  sem,
  semIdx,
  moveItem,
  updateSubjects,
  updateThemes,
  setAddSubjectOpen,
  setAddThemeOpen,
  removeSubject,
  removeTheme,
}) => {
  const { t } = useTranslation('common')

  return (
    <div className={`unv-card ${styles.semester}`}>
      <div className={styles.semesterHeader}>
        <h3>{sem.title || t('syllabus.semester_default', { n: semIdx + 1 })}</h3>
        <Button size="small" variant="outlined" onClick={() => setAddSubjectOpen(semIdx)}>
          {t('syllabus.add_subject')}
        </Button>
      </div>

      {(sem.subjects || []).map((subj, subjIdx) => (
        <SubjectBlock
          key={subj.id || subjIdx}
          subj={subj}
          semIdx={semIdx}
          subjIdx={subjIdx}
          moveItem={moveItem}
          updateSubjects={updateSubjects}
          updateThemes={updateThemes}
          setAddThemeOpen={setAddThemeOpen}
          removeSubject={removeSubject}
          removeTheme={removeTheme}
        />
      ))}
      {(sem.subjects || []).length === 0 && (
        <div className="unv-empty">{t('syllabus.no_subjects')}</div>
      )}
    </div>
  )
}

export default SemesterSection
